import { render, staticRenderFns } from "./JobsProfileAssignmentDetail.vue?vue&type=template&id=5ff87c86&scoped=true&"
import script from "./JobsProfileAssignmentDetail.vue?vue&type=script&lang=js&"
export * from "./JobsProfileAssignmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobsProfileAssignmentDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./JobsProfileAssignmentDetail.vue?vue&type=style&index=1&id=5ff87c86&scoped=true&lang=css&"
import style2 from "./JobsProfileAssignmentDetail.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./JobsProfileAssignmentDetail.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff87c86",
  null
  
)

export default component.exports